export enum EmailStatus {
  Created,
  Delayed,
  Sent,
  Failed,
  Delivered,
  Bounced
}
